module.exports = __webpack_public_path__ + "img/shape-35.bab5d461.svg";